import { Button, WImage } from '@components/atoms'
import { MenuItemType } from '@utils/types'
import styles from './BannerNewsletter.module.sass'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const BannerNewsletter = (props: Props) => {
  const { item, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <div className={`${styles.imageBox}`}>
        {!!item.image && (
          <WImage
            src={item.image}
            alt={item?.imageAlt}
            maxWidth={1920}
            maxHeight={762}
            objectFit="cover"
          />
        )}
      </div>

      <div className={`${styles.layoutWrap}`}>
        {(!!item.name || !!item.description) && (
          <div className={styles.main}>
            {(!!item.name || !!item.description) && (
              <div className={styles.content}>
                {!!item.name && <h3 className={styles.title}>{item.name}</h3>}
                {!!item.description && (
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                )}
                <Button href={item.url} label={item.ctaLabel} variant="ghost" size="lg" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default BannerNewsletter
